import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpCrudFactory } from '../../../utilities/http-crud-factory';
import { ItemEnvelope } from '../../../models/net/envelope/base/item-envelope';
import { CrudService } from '../crud/crud.service';

@Injectable({
    providedIn: 'root'
})

export class ScrudgService extends CrudService {

    public constructor(public override http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string, @Inject("") controllerName: string) {

        super(http, apiBaseUrl, controllerName);
    }

    public search(request: any): Observable<any | null> {

        const result = HttpCrudFactory.search<any, any>(this.http, this._controllerName, this._apiBaseUrl, request);

        return result;
    }

    public getBlankEnvelope(): Observable<ItemEnvelope | null> {

        const result = HttpCrudFactory.getBlankEnvelope<ItemEnvelope>(this.http, this._controllerName, this._apiBaseUrl);

        return result;
    }
}
